/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {PasswordSharingCriteria} from '../models/PasswordSharingCriteria';
import type {PasswordSharingEvent} from '../models/PasswordSharingEvent';

export interface GetPasswordSharingReport$Request {
    passwordSharingCriteria: PasswordSharingCriteria;
}

export interface GetPasswordSharingReport$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getPasswordSharingReportRequest = createAction<PayloadData<void, GetPasswordSharingReport$Request>>('PASSWORD_SHARING_REPORT__GET_PASSWORD_SHARING_REPORT__REQUEST');
export const getPasswordSharingReportSuccess = createAction<PayloadData<Array<PasswordSharingEvent>, GetPasswordSharingReport$Request>>('PASSWORD_SHARING_REPORT__GET_PASSWORD_SHARING_REPORT__SUCCESS');
export const getPasswordSharingReportFailure = createAction<PayloadData<Error, GetPasswordSharingReport$Request, true>>('PASSWORD_SHARING_REPORT__GET_PASSWORD_SHARING_REPORT__FAILURE');

export const getPasswordSharingReportActions = [
    getPasswordSharingReportRequest,
    getPasswordSharingReportSuccess,
    getPasswordSharingReportFailure
] as const;

/**
 * @param {PasswordSharingCriteria} meta.passwordSharingCriteria
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getPasswordSharingReport = (meta: GetPasswordSharingReport$Request, config?: GetPasswordSharingReport$Config) => {
    return {
        CALL_API: {
            types: getPasswordSharingReportActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/reports/password-sharing`,
            TRANSPORT_REQUEST_BODY: meta.passwordSharingCriteria,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

